<template>
  <div class="cardContainer">
    <lk-card title='购买者信息' class='buyerInfo'>
    <!-- 购药者信息 -->
    <div class='buyerInfoInner'>
      <lk-form ref="buyerInfo" :label-width="90" :model='info' :rules='validate' >
        <lk-form-item label="购药人姓名:" prop="purchaserName" >
          <lk-input :maxlength='30' placeholder='请输入' v-model="info.purchaserName" v-if="able"></lk-input>
          <span v-else>{{info.purchaserName || ''}}</span>
        </lk-form-item>
        <lk-form-item label="购药人年龄:" prop="purchaserAge">
          <lk-input
          :maxlength='4'
          placeholder='请输入'
          v-model="info.purchaserAge"
          number
          v-if="able"
          @on-change='handlerAge($event)'
        ></lk-input>
          <span v-else>{{info.purchaserAge || ''}}</span>
        </lk-form-item>
        <lk-form-item label="性别:" prop="purchaserSex">
          <lk-radio-group v-model="info.purchaserSex" v-if="able">
            <lk-radio v-for="(item,index) in genderList" :label="index*1" :key="index">
              <span>{{item}}</span>
            </lk-radio>
          </lk-radio-group>
          <span v-else>{{genderList[info.purchaserSex]}}</span>
        </lk-form-item>
        <lk-form-item label="身份证号码:" prop="idCard">
          <lk-input :maxlength='18' placeholder='请输入' v-model="info.idCard" v-if="able" @on-blur='handlerIdCard'></lk-input>
          <span v-else>{{info.idCard || ''}}</span>
        </lk-form-item>
        <lk-form-item label="联系方式:" prop="phone">
          <lk-input :maxlength='11' placeholder='请输入' v-model="info.phone" v-if="able"></lk-input>
           <span v-else>{{info.phone || ''}}</span>
        </lk-form-item>
        <lk-form-item label="购买原因:" prop="reason">
          <lk-input :maxlength='50' placeholder='请输入' v-model="info.reason" v-if="able"></lk-input>
          <span v-else>{{info.reason || ''}}</span>
        </lk-form-item>
        <lk-form-item label='与患者关系:' prop='relationship'>
          <lk-select v-model="info.relationship" v-if="able">
            <lk-option v-for="(item, index) in relationshipList" :key="index" :value='index*1'>
              {{ item }}
            </lk-option>
          </lk-select>
          <span v-else>{{relationshipList[info.relationship]}}</span>
        </lk-form-item>
        <lk-form-item label='配送方式:' prop='deliveryMethod'>
          <lk-select v-model="info.deliveryMethod" v-if="able">
            <lk-option v-for="(item, index) in orderTypeList" :key="item.id" :value='item.id'>
              {{ item.name }}
            </lk-option>
          </lk-select>
          <span v-else>{{deliveryTypeName}}</span>
        </lk-form-item>
      </lk-form>
    </div>
  </lk-card>
  </div>
</template>

<script>
import utils from '../../libs/utils';
import CredentialsInput from '../CredentialsInput';

export default {
  name: 'BuyerInfo',
  components: {
    CredentialsInput,
  },
  props: {
    purchaserQo: {
      type: Object,
    },
    able: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: 'purchaserQo',
    event: 'change',
  },
  computed: {
    deliveryTypeName() {
      if (this.info && this.info.deliveryMethod) {
        let obj = this.orderTypeList.find(item => item.id == this.info.deliveryMethod);
        if (obj) {
          return obj.name;
        }
      }
    }
  },
  watch: {
    purchaserQo: {
      handler(val) {
        this.info = this.purchaserQo;
      },
      deep: true,
    },
  },
  data() {
    return {
      orderTypeList: [
        {
          id: 2,
          name: '门店自提'
        },
        {
          id: 3,
          name: '门店配送'
        }
      ],
      info: {},
      genderList: {
        1: '男',
        2: '女',
      },
      relationshipList: {
        1: '患者本人',
        2: '患者配偶',
        3: '患者子女',
        4: '患者家属',
        5: '其他',
      },
      validate: {
        purchaserName: [
          {
            required: true,
            message: '请输入购药人姓名',
            trigger: 'blur',
          }
        ],
        idCard: [
          {
            validator: utils.validate.IDValidator,
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            message: '请输入联系方式',
            trigger: 'change',
          },
          {
            validator: utils.validate.cellPhoneValidator,
            trigger: 'change'
          },
        ],
        relationship: [
          {
            required: true,
            message: '请选择与患者关系',
            trigger: 'change',
            type: 'number',
          },
        ],
        deliveryMethod: [
          {
            required: true,
            message: '请选择配送方式',
            trigger: 'change',
            type: 'number',
          },
        ]
      },
    }
  },
  methods: {
    handlerAge(e) {
      let age = e.target.value
      this.info.purchaserAge = Number(age.replace(/\D/g,''));
    },
    handlerIdCard() {
      let age = utils.idCardChange(this.info.idCard);
      if (age < 0) {
        this.$Message.error('请输入正确的身份证号码');
        age = null;
      }
      this.$set(this.info, 'purchaserAge', age);
    },
    validateForm() {
      this.$emit('change', this.info);
      return new Promise((resolve) => {
        this.$refs.buyerInfo.validate((valid) => {
          resolve(valid);
        });
      });
    },
  },

  created() {
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.cardContainer{
  height: 100%;
  .buyerInfo{
    height: 100%;
    margin-right:8px;
    /deep/ .ivu-card-head {
      padding: 8px 16px;
      border-bottom: none;
    }
  }
}
</style>
